export const driveType: { [key: number]: string } = {
  1: 'FWD',
  2: 'RWD',
  3: 'FourWD',
  4: 'AWD',
};
